import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "How does SlimBuddy's AI food recognition work?",
      answer: "Our advanced AI analyzes your food photos using computer vision and machine learning. It identifies ingredients, portions, and calculates nutritional information including calories and macros in seconds. You can also use text and audio inputs to talk to AI."
    },
    {
      question: "How accurate is it?",
      answer: "The short answer is 'Accurate enough.' Of course, it will be less accurate than if you measure all the portions on scales and cook all your food from scratch, but who has time for that. SlimBuddy is generally accurate in estimating portion sizes, calories and macros. More importantly, it is very simple and convenient to use. Consistency beats absolute accuracy. Fun fact: the U.S regulations allow nutritional information on packaging to be up to 20% off. So, there is no such thing as absolutely accurate calorie tracking."
    },
    {
      question: "Can I sync SlimBuddy with Garmin/Oura/Whoop/Polar or other fitness devices?",
      answer: "Yes! SlimBuddy seamlessly integrates with Apple Health. If your exercise data imports to Apple Health, SlimBuddy will pick it up."
    },
    {
      question: "How much does SlimBuddy cost?",
      answer: "SlimBuddy offers trial period of 14-days. If you like, you can keep using SlimBuddy at $9.99/month or $99.99/year."
    },
    {
      question: "Do I need to take photos of every meal?",
      answer: "Nope. You can also manually log foods or use voice commands. The app is flexible to fit your lifestyle and preferences."
    }
  ];

  return (
    <section className="faq" id="faq">
      <div className="container">
        <div className="faq-header">
          <h2>Frequently Asked Questions</h2>
          <p>Get answers to common questions about SlimBuddy and how it can transform your health journey</p>
        </div>
        <div className="faq-grid">
          {faqData.map((item, index) => (
            <div key={index} className={`faq-item ${openItems[index] ? 'open' : ''}`}>
              <button 
                className="faq-question"
                onClick={() => toggleItem(index)}
                aria-expanded={openItems[index]}
              >
                <span>{item.question}</span>
                <div className="faq-icon">
                  {openItems[index] ? '−' : '+'}
                </div>
              </button>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;